export default "__VITE_ASSET__Ch1oo2J$__"